/**
 * @generated SignedSource<<0a0f9dfbe8174bc0e3bec1f9dbfdfaa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildMetadata_guild$data = {
  readonly backgroundPhoto: {
    readonly coverUrl: string;
  } | null | undefined;
  readonly defaultCoverUrl: string;
  readonly description: string | null | undefined;
  readonly name: string;
  readonly slugId: string;
  readonly " $fragmentType": "GuildMetadata_guild";
};
export type GuildMetadata_guild$key = {
  readonly " $data"?: GuildMetadata_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildMetadata_guild">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "transform",
    "value": {
      "dpr": 1,
      "fit": "cover",
      "h": 600,
      "w": 1200
    }
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildMetadata_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        {
          "alias": "coverUrl",
          "args": (v0/*: any*/),
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":600,\"w\":1200})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "defaultCoverUrl",
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "defaultBackgroundUrl",
      "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":600,\"w\":1200})"
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
})();

(node as any).hash = "f29f91da36a56ad528323af3b73b9188";

export default node;
